import { ref, computed } from 'vue'
import { employeur } from '@/profils/employeur'
import { expert } from '@/profils/expert'
import { salarie } from '@/profils/salarie'
import { retraite } from '@/profils/retraite'
import { prospect } from '@/profils/prospect'

// User
const user = ref({});

const useUser = {
  getUserProfil : () => {
    const { profil } = user.value
    const getUserProfilQuery = computed(() => profil )
    return getUserProfilQuery.value
  },
  setUserProfil: (profil) => {
    switch (profil) {
      case 'Employeur' :
        user.value = employeur
        break;
      case 'Expert' :
        user.value = expert
        break;
      case 'Salarie' :
        user.value = salarie
        break;
      case 'Retraite' :
        user.value = retraite
        break;
      default :
        user.value = prospect
    }
  },
  isExpert: () => {
    const { profil } = user.value
    return profil === 'Expert'
  },
  isProspect: () => {
    const { profil } = user.value
    return profil === 'Prospect'
  }
}

export { user, useUser }
